import React from 'react';
import './index.css';
import Toast from '../common/Toast'
import util from "../../util/tools";
const title = "中秋活动"
const rechargeConfig = [
    {
        value:15,
        style:{
            position:"absolute",
            top:"4.1rem",
            left:"0.4rem",
            width:"6.6rem",
            height:"1rem",
        }
    },
    {
        value:28,
        style:{
            position:"absolute",
            top:"5.3rem",
            left:"0.4rem",
            width:"6.6rem",
            height:"1rem",
        }
    }
]
const rechargeType = "zhongqiu" //todo:

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            weixinurl: "",
            bookId: "",
            hongbao:'',
            coin:'',
            text:''
        };
    }

    setHeight = () => {
        let height = document.documentElement.clientHeight || window.innerHeight
        let recharge = document.getElementById("recharge")
        recharge.style.height = height+"px"
    }

    componentDidMount() {
        this.setHeight()
        document.title = title
        this.setState({
            bookId: this.props.match.params.bookId,
            weixinurl: this.props.match.params.weixinurl
        },()=>{
            this.getUserInfo()
        })
    }

    getUserInfo(){
        util.ajax({
            url: "/zh/user/userInfo",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data
                    this.setState({
                        coin:data.user_money.coin,
                        hongbao:data.user_money.hongbao
                    })
                }
            }
        });
    }

    showText(text){
        this.setState({
            text:text
        },()=>{
            setTimeout(()=>{
                this.setState({
                    text:"",
                })
            },2000)
        })
    }

    recharge(item,index){
        if(!item){return false;}
        let url = this.state.weixinurl || `${document.location.href}`
        let params = {
            'total_fee':item*100,
            'back_url':url,
            'error_url':url,
            [rechargeType]: 1
        }
        if(!!this.state.bookId){
            params.book_id = this.state.bookId
        }
        util.ajax({
            url: "/zh/pay/wgpay",
            method:'post',
            isUser: true,
            isWechatId: true,
            data: params,
            callback: res => {
                if (res.result.status.code == 0) {
                    document.location.href = res.result.data.url
                }else {
                    this.showText(res.result.status.msg);
                }
            }
        });
    }

    goRoute(){
        this.props.history.push('/balance')
    }

    render() {
        return (
            <div className='midautumnrecharge' style={{background:"#003f6a"}}>
                <div className='recharge' id="recharge" style={{overflow:"inherit"}}>
                    <div className='recharge_items'>
                        <img style={{width:"100%"}} src={require("../../../common/images/midautumn.jpg")} />
                        {(rechargeConfig || []).map((item,index)=>{
                            let value = item.value
                            return (
                                <div style={item.style} onClick={()=>this.recharge(value,index)} key={`r${index}`}></div>
                            )
                        })}
                    </div>
                </div>
                <Toast text={this.state.text}/>
            </div>
        );
    }
}